import React from 'react';

// Icons
export const TextIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="12" height="1" fill="currentColor"/>
    <rect x="2" y="7" width="8" height="1" fill="currentColor"/>
    <rect x="2" y="10" width="10" height="1" fill="currentColor"/>
  </svg>
);

export const ParagraphIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="3" width="12" height="1" fill="currentColor"/>
    <rect x="2" y="5" width="10" height="1" fill="currentColor"/>
    <rect x="2" y="7" width="12" height="1" fill="currentColor"/>
    <rect x="2" y="9" width="8" height="1" fill="currentColor"/>
    <rect x="2" y="11" width="11" height="1" fill="currentColor"/>
  </svg>
);

export const RadioIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="4" cy="4" r="2" stroke="currentColor" fill="none"/>
    <circle cx="4" cy="8" r="2" stroke="currentColor" fill="none"/>
    <circle cx="4" cy="12" r="2" stroke="currentColor" fill="none"/>
    <rect x="8" y="3" width="6" height="2" fill="currentColor"/>
    <rect x="8" y="7" width="4" height="2" fill="currentColor"/>
    <rect x="8" y="11" width="5" height="2" fill="currentColor"/>
  </svg>
);

export const DropdownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="12" height="8" stroke="currentColor" fill="none"/>
    <path d="M12 7L8 10L4 7" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export const OpenListIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="12" height="8" stroke="currentColor" fill="none" strokeDasharray="2,2"/>
    <path d="M6 7h4M6 9h4" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export const DateIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="3" width="12" height="10" stroke="currentColor" fill="none"/>
    <rect x="5" y="1" width="1" height="4" fill="currentColor"/>
    <rect x="10" y="1" width="1" height="4" fill="currentColor"/>
    <rect x="2" y="6" width="12" height="1" fill="currentColor"/>
  </svg>
);

export const NumberIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 2v12M10 2v12M2 6h12M2 10h12" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const CheckboxIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="4" height="4" stroke="currentColor" fill="none"/>
    <path d="M3 6l1 1 2-2" stroke="currentColor" strokeWidth="1"/>
    <rect x="8" y="5" width="6" height="2" fill="currentColor"/>
  </svg>
);

export const TimeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="currentColor" fill="none"/>
    <path d="M8 4v4l3 2" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export const UserIcon = ({ className }: { className?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
    <circle cx="8" cy="5" r="3" stroke="currentColor" fill="none"/>
    <path d="M2 14a6 6 0 0112 0" stroke="currentColor" fill="none"/>
  </svg>
);

export const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="4" y="2" width="8" height="12" rx="2" stroke="currentColor" fill="none"/>
    <rect x="6" y="12" width="4" height="1" fill="currentColor"/>
  </svg>
);

export const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="12" height="8" stroke="currentColor" fill="none"/>
    <path d="M2 4l6 4 6-4" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export const DocumentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 2h6l2 2v10H4V2z" stroke="currentColor" fill="none"/>
    <path d="M10 2v2h2" stroke="currentColor" fill="none"/>
  </svg>
);

export const DepartmentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="6" width="12" height="8" stroke="currentColor" fill="none"/>
    <rect x="6" y="2" width="4" height="6" stroke="currentColor" fill="none"/>
    <rect x="4" y="8" width="2" height="2" fill="currentColor"/>
    <rect x="6" y="8" width="2" height="2" fill="currentColor"/>
    <rect x="8" y="8" width="2" height="2" fill="currentColor"/>
    <rect x="10" y="8" width="2" height="2" fill="currentColor"/>
  </svg>
);

export const CountryIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="currentColor" fill="none"/>
    <path d="M2 8h12M8 2a12 12 0 010 12" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export const FileIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M9 2H4a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2V7l-5-5z" stroke="currentColor" fill="none"/>
    <path d="M9 2v5h5" stroke="currentColor" fill="none"/>
  </svg>
);

export const ApiIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="3" width="12" height="2" rx="1" fill="currentColor"/>
    <rect x="2" y="7" width="8" height="2" rx="1" fill="currentColor"/>
    <rect x="2" y="11" width="10" height="2" rx="1" fill="currentColor"/>
    <circle cx="12" cy="8" r="1" fill="currentColor"/>
    <circle cx="14" cy="12" r="1" fill="currentColor"/>
  </svg>
);

export const ChevronDownIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const HumanIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <circle cx="6" cy="3" r="1.5" stroke="currentColor" fill="none"/>
    <path d="M6 4.5v3M4 6.5l2-1 2 1M3.5 11c0-1.5 1-2.5 2.5-2.5s2.5 1 2.5 2.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);